import styled from 'styled-components';

export const DashboardContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DashboardHeader = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.White};
`;

export const DashboardTitle = styled.h1`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 0;
`;

export const DashboardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.Grey1};
`;

export const WidgetGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const TallWidgetCell = styled.div`
  display: grid;
  grid-row: span 2;

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    grid-row: auto;
  }
`;

export const FullWidthSection = styled.div`
  width: 100%;
`;

export const DashboardLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  width: 100%;
`;

export const DashboardErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  width: 100%;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.ErrorDefault};
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  gap: 8px;
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const PlaceholderText = styled.span`
  font-size: 14px;
`;

export const PlaceholderSubtext = styled.span`
  font-size: 12px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const ChartScrollContainer = styled.div`
  width: 100%;
  max-height: 450px;
  min-height: 160px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
`;

export const ChartLoadMoreRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  width: 100%;
`;

export const ChartScrollSentinel = styled.div`
  height: 1px;
  width: 100%;
  flex-shrink: 0;
`;

export const TooltipContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 1000;
  background-color: ${({ theme }) => theme.colors.TextDarkGrey};
  color: ${({ theme }) => theme.colors.White};
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  ${({ theme }) => theme.fonts.PoppinsText};
  white-space: nowrap;
`;
